// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RepeatOutlinedSvg from "@fishx/icons-svg/es/asn/RepeatOutlined";
import FishxIcon from '../components/FishxIcon';

var RepeatOutlined = function RepeatOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RepeatOutlinedSvg
  }));
};

RepeatOutlined.displayName = 'RepeatOutlined';
export default React.forwardRef(RepeatOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RepeatOutlined.js
// module id = 4002
// module chunks = 0